import { CTAFunction } from "../../../api/cta/ctaFunction/CTAFunction";
import { PlayerCTAAPI } from "../../../api/cta/PlayerCTAAPI";
import { ClickableButtonCTAConfiguration } from "./ClickableButtonCTAConfiguration";
import DOMPurify from "dompurify";

const ACTION_ID = 0;

export const clickableButtonCTAFunction: CTAFunction =
  (api: PlayerCTAAPI, ctaId: number, ctaBoard: HTMLElement, config: ClickableButtonCTAConfiguration) => {

    const clickableButton = document.createElement("div");

    clickableButton.setAttribute("class", "clickableAreaItemButtons");
    clickableButton.style.top = `${parseInt(config.top, 0)}%`;
    clickableButton.style.bottom = `${parseInt(config.bottom, 0)}%`;
    clickableButton.style.left = `${parseInt(config.left, 0)}%`;
    clickableButton.style.right = `${parseInt(config.right, 0)}%`;
    
    if (config.rounded === true) {
      clickableButton.classList.add("roundedBorders");
    }

    if (config.outline === true) {
      clickableButton.classList.add("ctaButtonBorders");
    }

    if (config.bgrcolor) {
      clickableButton.style.backgroundColor = config.bgrcolor;
    }

    if (config.color) {
      clickableButton.style.color = config.color;
    }

    if (config.buttontext) {
      const p = document.createElement("p");
      p.innerHTML = DOMPurify.sanitize(config.buttontext);
      clickableButton.appendChild(p);
      clickableButton.style.fontSize = `${config.textsize}px`;
    }

    clickableButton.onclick = () => {
      if (config.scenarioElementId) {
        api.jumpToScenarioElement(config.scenarioElementId);
      } else {
        window.open(config.url, "_blank");
      }
      api.onCTAAction(ctaId, ACTION_ID);
    };

    const container = ctaBoard.querySelector("[data-role='container']");
    container.appendChild(clickableButton);

    return {
      action: () => {}
    };
  };
